module.exports = __webpack_public_path__ + "img/submit-button-old.0a60b505.png";